import { Grid, useMediaQuery } from "@mui/material";
import { Labeled, TextField, useRecordContext } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const NotesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record?.comment && !record?.rejectionComment) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Бележки"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {record.comment ? (
          <Grid
            item
            xs={12}
          >
            <Labeled label="Коментар">
              <TextField
                source="comment"
                emptyText="-"
              />
            </Labeled>
          </Grid>
        ) : null}

        {record.rejectionComment ? (
          <Grid
            item
            xs={12}
          >
            <Labeled label="Причина за отказ">
              <TextField
                source="rejectionComment"
                emptyText="-"
              />
            </Labeled>
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default NotesSection;
